import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';

import { formatCOP, imageUrl } from '../services/api';

import SearchBar from '../components/SearchBar';

import CategoryFilter from '../components/CategoryFilter';
import ProductPreview from '../components/ProductPreview';
import LoadMoreSentinel from '../components/LoadMoreSentinel';
import usePaginatedProductos from '../hooks/usePaginatedProductos';
import { categoriaLabel } from '../utils/categorias';
import { displayNombre } from '../utils/productName';

function getScrollEl() {
  return document.querySelector('.app-main') || document.scrollingElement;
}

function readScroll() {
  const el = getScrollEl();
  return el?.scrollTop ?? window.scrollY ?? 0;
}

function writeScroll(y) {
  const el = getScrollEl();
  if (el && el !== document.scrollingElement) el.scrollTop = y;
  else window.scrollTo(0, y);
}



export default function Productos({ onToast }) {

  const [q, setQ] = useState('');

  const [debouncedQ, setDebouncedQ] = useState('');

  const [categoria, setCategoria] = useState('Todas');
  const [preview, setPreview] = useState(null);
  const scrollLockY = useRef(null);



  useEffect(() => {

    const t = setTimeout(() => setDebouncedQ(q), 300);

    return () => clearTimeout(t);

  }, [q]);



  const handleError = useCallback((message) => {

    onToast?.(message, 'error');

  }, [onToast]);



  const { productos, total, loading, loadingMore, hasMore, loadMore, shown } = usePaginatedProductos({

    q: debouncedQ,

    categoria,

    onError: handleError,

  });



  const countLabel =
    categoria === 'Todas'
      ? `${total} productos`
      : `${shown} de ${total} en ${categoriaLabel(categoria) || categoria}`;

  useLayoutEffect(() => {
    if (scrollLockY.current == null) return;
    writeScroll(scrollLockY.current);
  }, [categoria, loading, productos.length]);

  useEffect(() => {
    if (scrollLockY.current == null) return undefined;
    const y = scrollLockY.current;
    writeScroll(y);
    const id = window.requestAnimationFrame(() => {
      writeScroll(y);
      if (!loading) scrollLockY.current = null;
    });
    return () => window.cancelAnimationFrame(id);
  }, [categoria, loading, productos.length]);

  return (
    <section className="page">

      <header className="page-header">

        <h1>Ver productos</h1>

        <p>Catálogo completo · {loading && !productos.length ? '…' : countLabel}</p>

      </header>



      <SearchBar value={q} onChange={setQ} onClear={() => setQ('')} />
      <CategoryFilter
        value={categoria}
        onChange={(c) => {
          scrollLockY.current = readScroll();
          setCategoria(c);
        }}
      />

      {loading && !productos.length ? (
        <p className="loading-grid">Cargando productos...</p>
      ) : (
        <div className="product-list-admin">
          {productos.map((p) => {

            const img = imageUrl(p.imagen);

            const name = displayNombre(p) || `Cód. ${p.codigo}`;

            return (

              <button key={`${p.id ?? 'p'}-${p.codigo}`} type="button" className="product-row" onClick={() => setPreview(p)}>

                {img ? <img src={img} alt="" /> : <div className="product-row-img-empty" />}

                <div>

                  <strong>{name}</strong>

                  <span>Código {p.codigo} · {formatCOP(p.precio)}</span>

                  {p.subcategoria ? <em>{p.subcategoria}</em> : null}

                </div>

              </button>

            );

          })}

        </div>

      )}



      {!loading && !productos.length ? (
        <p className="empty-state">No hay productos con esa búsqueda o categoría</p>
      ) : null}

      {hasMore ? (
        <div className="load-more-wrap">
          <LoadMoreSentinel onVisible={loadMore} disabled={loadingMore || loading} />
          <button
            type="button"
            className="btn-secondary load-more-btn"
            disabled={loadingMore}
            onClick={loadMore}
          >
            {loadingMore ? 'Cargando…' : `Cargar más (${shown} de ${total})`}
          </button>
        </div>
      ) : null}



      {preview ? (

        <ProductPreview

          product={preview}

          products={productos}

          onNavigate={setPreview}

          onClose={() => setPreview(null)}

          onAdd={() => {

            setPreview(null);

            onToast?.('Ve a Nuevo pedido para agregar al carrito', 'ok');

          }}

        />

      ) : null}

    </section>

  );

}

